<template>
    <div class="modal fade" id="reservationDetails" tabindex="-1" role="dialog" aria-labelledby="reservationDetailsTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-weight-bold" id="reservationDetailsTitle">{{reservation.crew ? reservation.crew : ''}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="setAllNull">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6 text-left">
                                    <div class="form-group">
                                        <label for="batchNoEdit" class="font-weight-bold">Batch No :</label>
                                        <span class="form-control form-control-lg" v-if="!isActive">{{reservation.batch ? reservation.batch.batch_no : ''}}</span>
                                        <multiSelect v-model="crewEndorse.batch" :options="batchKeyDetails" :custom-label="batchNoDtls" v-if="isActive"
                                                     placeholder="Search Batch no."
                                                     :select-label="'Select'"
                                                     label="Batch No"
                                                     track-by="id"
                                                     :optionsLimi="1000"
                                                     id="batchNoEdit"
                                                     class="p-0 form-control">
                                        </multiSelect>
                                    </div>

                                    <div class="form-group">
                                        <label for="vessel" class="font-weight-bold">Intended Vessel:</label>
                                        <!--                                        <input type="text" readonly class="form-control form-control-sm text-muted border-top-0 border-left-0 border-right-0" v-if="crewEndorse.batch" v-model="crewEndorse.batch.vessel" id="vessel" aria-describedby="endorsedBy" placeholder="Enter email">-->
                                        <span class="form-control form-control-sm" id="vessel">{{reservation.batch ? reservation.batch.vessel : ''}}</span>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorseCheckIn" class="col-sm-5 col-form-label font-weight-bold">Endorsed Check-In :</label>
                                        <div class="col-sm-6">
                                            <input type="date"
                                                   class="form-control form-control-sm"
                                                   id="endorseCheckIn" placeholder="Email"
                                                   v-model="reservation.endorsed_check_in"
                                                   :disabled="!isActive">
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorseCheckOut" class="col-sm-5 col-form-label font-weight-bold">Endorse Check-Out :</label>
                                        <div class="col-sm-6">
                                            <input type="date"
                                                   class="form-control form-control-sm"
                                                   id="endorseCheckOut"
                                                   v-model="reservation.endorsed_check_out"
                                                   :disabled="!isActive">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="purposesDiv" class="font-weight-bold">Purposes :</label>
                                        <div class="col-sm-9 text-left ml-4" id="purposesDiv">
                                            <div class="form-check mt-2" v-for="purpose in purposes" :key="purposes.id">
                                                <input class="form-check-input" type="checkbox" :id="'purpose'+purpose.id" :value="purpose.id" v-model="reservation.purposes" :disabled="!isActive">
                                                <label class="form-check-label ml-3 custom-text" :for="'purpose'+purpose.id">{{titleCase(purpose.description)}}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class=" font-weight-bold">PCR File:</label>
                                        <div class="col-sm-12">
                                            <div class="table-responsive-sm small">
                                                <table class="table">
                                                    <thead>
                                                    <tr>
                                                      <th scope="col" class="p-1">Swab Date</th>
                                                      <th scope="col" class="p-1 text-center">Days to Expire</th>
                                                      <th scope="col" class="p-1 text-center">View</th>
                                                    </tr>
                                                    </thead>

                                                    <tbody>
                                                    <tr v-if="reservation.pcrFile" v-bind:class="checkExpiredPCR(reservation.pcrFile)">
                                                        <td class="p-1">{{reservation.pcrFile.pcr_swab_date | moment("DD MMM YYYY")}}</td>
                                                        <td class="p-1 text-center">{{reservation.pcrFile.days_to_expire}}</td>
                                                        <td class="p-1 text-center">
                                                            <button class="btn btn-xsm tnkc-secondary"
                                                                    v-if="reservation.pcrFile != null"
                                                                    v-on:click="viewPcrFile(reservation.pcrFile.id)">
                                                                <font-awesome-icon icon="file"/>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table >
                                            </div>

                                            <!-- <button class="btn btn-sm tnkc-secondary ml-3">
                                                 <font-awesome-icon icon="file"/>
                                             </button>
                                             <sup>{{crewEndorse.pcrFile ? crewEndorse.pcrFile.issued_date : ''}}</sup>
                                             <small id="emailHelp" class="form-text text-muted">We'll never share your pcr with anyone else.</small>-->
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6 border-left text-left">
                                    <div class="form-group row ">
                                        <label  class="font-weight-bold ml-3">Previous Remarks :</label>
                                    </div>

                                    <div class="form-group custom-scroll remarks-wrapper"  style="height:180px;">
                                        <div>
                                            <div class="card mb-3" v-for="(remark,index) in remarks" :key="remark.id" :id="'cardRemarks'+index">
                                                <div class="card-body">
                                                    <div class="card-title custom-label text-dark border-bottom">{{remark.subject ? remark.subject : '---'}}</div>
                                                    <div class="card-text">
                                                        <p>{{remark.remarks}}</p>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="row" style="font-size: 12px;" >
                                                                <div class="col-sm-6">
                                                                    <small class="text-muted">Created At : </small> <small class="font-weight-bold">{{remark.created_at | moment("DD MMM YYYY - HH:mm") }}</small>
                                                                </div>
                                                                <div class="col-sm-6 border-left border-dark">
                                                                    <small class="text-muted">By : </small><small class="font-weight-bold">{{remark.remark_by}}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="border">
                                    <div class="form-group row mt-3">
                                        <label for="endorsedBy" class="col-sm-5 col-form-label">Endorsed By:</label>
                                        <div class="col-sm-7">
                                            <span id="endorsedBy" class="form-control form-control-sm text-muted">{{reservation.endorsedBy }}</span>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label for="endorsedAt" class="col-sm-5 col-form-label">Endorsed At:</label>
                                        <div class="col-sm-7">
                                            <span id="endorsedAt" class="form-control form-control-sm text-muted">{{reservation.endorsedAt | moment("DD MMM YYYY - HH:mm") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn tnkc-success" v-if="isActive" @click="save">
                        <font-awesome-icon icon="save"/>
                        Save changes
                    </button>
                    <button type="button" class="btn tnkc-danger" v-if="isActive" @click="isActive = !isActive">
                        <font-awesome-icon icon="times"/>
                        Cancel
                    </button>
                    <button type="button" class="btn btn-secondary" v-if="!isActive"  data-dismiss="modal" v-on:click="setAllNull">
                        <font-awesome-icon icon="times"/>
                        Close
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions,mapGetters} from 'vuex';
  import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'reservationDtls',
    mixins:[appMixins],
    data(){
      return{
        isActive: false
      }
    },
    methods:{

      ...mapActions(['getPurposeList','setNullReservation','setNullRemarks', 'getPCRFile']),

      setAllNull(){
       this.setNullReservation();
       this.setNullRemarks();
      },

      checkExpiredPCR(obj){
        // console.log(obj);
        if (obj.days_to_expire < 0 ){
          return 'bg-expired';
        }
      },

      viewPcrFile(id){
        this.getPCRFile({pcr_id : id}).then((res)=>{
          if(res == true){
            this.viewPdfFile(this.pcrFile);
          }
        });
      }
    },

    computed:{
      ...mapGetters(['reservation','remarks','purposes','pcrFile'])

    },


    created() {
      this.getPurposeList();
    },

    mounted() {

    },

  };
</script>

<style scoped>

    input[type=checkbox] {
        transform: scale(2);
    }


    .remarks-wrapper{
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>